import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpSubmitProPhotosExperienceOptions,
	httpSubmitProPhotosExperience
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useSubmitProPhotosExperience = (
	urlParams: HttpSubmitProPhotosExperienceOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpSubmitProPhotosExperienceOptions['payload']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpSubmitProPhotosExperience({
				urlParams,
				payload,
				params: {
					responseType: 'extended'
				}
			}),
		onError: (error) => errorHandler(error),
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [
					QUERY_KEYS.EXPERIENCE_VETTING,
					urlParams.experienceId
				]
			})
			queryClient.setQueriesData(
				{
					queryKey: [
						QUERY_KEYS.EXPERIENCE_VETTING,
						urlParams.experienceId
					]
				},
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
